import { Loader2 } from "lucide-react";

export const PageLoader = ({ label = "Memuat data..." }) => (
  <div
    className="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-zinc-500"
    data-testid="page-loader"
  >
    <Loader2 className="w-8 h-8 animate-spin text-primary" strokeWidth={2} />
    <p className="text-sm font-medium">{label}</p>
  </div>
);
